// Palette centralisée du dashboard (évite les couleurs en dur éparpillées).
const colors = {
  brand: "#4A9FC2",     // bleu KyrnovaRent
  tyllt: "#1579DB",     // badge caution Tyllt
  airbnb: "#FF5A5F",    // badge caution Airbnb (coral)
  success: "#4CAF50",   // confirmée / payée
  danger: "#C24A4A",    // annulée / action de retrait
  neutral: "#707070",   // indisponible / propriétaire
  warning: "#FF9800",   // autre statut
  white: "#FFFFFF",
  text: "#1F2733",
  border: "#D6DAE1",
};

export default colors;
